import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { Icon, Img, LinkStyled, MenuItem, MenuLabel } from './TopBar.styles'
import Badge from '../../Badge'
import { buildRoute } from '../../../constants/routes'
import { useAppSelector } from '../../../reducers'

function MenuItemSimple(props) {
    const {
        highlight,
        icon,
        img,
        isSubmenu,
        name,
        onClickLinkWrapper,
        pathname,
        route,
    } = props
    const highlighted = useAppSelector((state) => (typeof highlight === 'function' ? highlight(state) : !!highlight))
    const selectedEstate = useAppSelector((state) => state.app.selectedEstate)

    const { t } = useTranslation()

    const finalRoute = route ? buildRoute(route, { estate: selectedEstate }) : undefined

    return (
        <MenuItem
            isSubmenu={isSubmenu}
            key={name}
            selected={finalRoute && finalRoute === pathname}
            onClick={() => onClickLinkWrapper(finalRoute)}
        >
            <LinkStyled to={finalRoute}>
                {icon && <Icon icon={icon} />}
                {img && <Img src={img} />}
                <MenuLabel>{t(name)}</MenuLabel>
                {highlighted && <Badge inline />}
            </LinkStyled>
        </MenuItem>
    )
}

MenuItemSimple.propTypes = {
    highlight: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    icon: PropTypes.string,
    isSubmenu: PropTypes.bool,
    name: PropTypes.string,
    onClickLinkWrapper: PropTypes.func,
    pathname: PropTypes.string,
    route: PropTypes.string,
}

MenuItemSimple.defaultProps = {
    highlight: false,
    icon: '',
    isSubmenu: false,
    name: '',
    onClickLinkWrapper: () => null,
    pathname: '',
    route: '',
}

export default MenuItemSimple
